exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "td {\n  padding: 2px 2px;\n  display: table-cell;\n  text-align: left;\n  vertical-align: middle;\n  border-radius: 2px;\n  font-family: 'Roboto', sans-serif;\n}\n\nth{\n  padding: 2px 0px 2px;\n  text-align: left;\n  vertical-align: middle;\n  border-radius: 2px;\n  font-family: 'Roboto', sans-serif;\n}\n\n.material-icons.remove-red { color: #e57373; }\n.material-icons.mrc-blue { color: #27476E; }\n\n.material-icons.md-18 { font-size: 18px; }\n.material-icons.md-24 { font-size: 24px; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/mark/Documents/Source/MachineResearch/MR2/angular2/src/app/quotedocument/quotedocument.component.css
// module id = ../../../../../src/app/quotedocument/quotedocument.component.css
// module chunks = main